import { useEffect } from 'react';
import FJImageManipulationRightContainer from './right/container/FJImageManipulationRightContainer';
import { useDispatch } from 'react-redux';
import FJActionImageManipulation from '../../redux/action/FJActionImageManipulation';
import FJImageManipulationLeftContainer from './left/container/FJImageManipulationLeftContainer';

const FJImageManipulation = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(FJActionImageManipulation.loadImageManipulationPageAction());
    }, []);

    return (
        <>
            <FJImageManipulationLeftContainer />
            <FJImageManipulationRightContainer />
        </>
    );
};

export default FJImageManipulation;
